import decorOneColor from './decor-1-color.html';
import decorAllColors from './decor-all-colors.html';
import stickersAllColors from './stickers-all-colors.html';

export default {
  "decor-1-color": decorOneColor,
  "decor-all-colors": decorAllColors,
  "stickers-all-colors": stickersAllColors
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/templates/decor-decals-stickers/index.js
 **/